var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.94597L3.95954 9.3804L7.91936 8.81484L5.27214 6.1679C7.17966 3.86669 10.0591 2.40027 13.2818 2.40027C19.0255 2.40027 23.6816 7.05661 23.6816 12.8003C23.6816 18.5441 19.0255 23.2001 13.2818 23.2001C9.80938 23.2001 6.73488 21.4981 4.84599 18.8824L2.89726 20.2837C5.2219 23.5038 9.00675 25.6001 13.2818 25.6001C20.3511 25.6001 26.0816 19.8696 26.0816 12.8003C26.0816 5.73103 20.3514 0 13.2821 0C9.39677 0 5.91645 1.73142 3.56923 4.46414L1.13142 2.02633L0.565567 5.98643L0 9.94597Z",
    fill: "#10151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.71a5330cef4da662542e46ee30f035cc.svg";
export { ForwardRef as ReactComponent };